import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ALLOCATION_MAP_KEY } from '../analytics/constants';
import { siteConfig } from './siteConfig';
import isProduction from '../standalone/isProduction';
import { captureError } from './errors';
export var getFeatureFlags = function getFeatureFlags() {
  var alffRegex = /al_ff=([^\s;]+)/;
  var alffMatch = document.cookie.match(alffRegex);
  if (alffMatch) {
    try {
      // Base64 conversion adds one or two `=` at the end of the resulting string when padding is needed.
      // This is encoded as `%3D` when it hits the user's cookies. Reverse this to ensure we can decode.
      var base64String = alffMatch[1].replace(new RegExp('%3D', 'g'), '=');
      // archie@edge encodes the feature flag object in base64.
      var jsonString = window.atob(base64String);
      return JSON.parse(jsonString);
    } catch (e) {
      captureError(e);
    }
  }
  return {};
};
export var getAllocationMap = function getAllocationMap() {
  return getFeatureFlags()[ALLOCATION_MAP_KEY];
};
export var getFileExtension = function getFileExtension(filename) {
  var extRegex = /(?:\.([^.]+))?$/;
  var fileExtension = extRegex.exec(filename);
  if (fileExtension) {
    return fileExtension[1];
  }
};
export var parseJwt = function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
};
export var getPaperName = function getPaperName(isResubmit, filename) {
  if (isResubmit && filename) {
    var version = 'v2';
    try {
      var _filename$split = filename.split(' - '),
        _filename$split2 = _slicedToArray(_filename$split, 2),
        name = _filename$split2[0],
        dateAndExtension = _filename$split2[1];
      var versionIndex = name.toLowerCase().indexOf('v');
      if (versionIndex > -1) {
        var versionNum = parseInt(name.slice(versionIndex + 1));
        version = "v".concat(versionNum + 1);
      }
      return "My Paper ".concat(version, " - ").concat(dateAndExtension);
    } catch (_unused) {
      console.error('Error incrementing paper version');
    }
  }
  return "My Paper - ".concat(new Date().toLocaleDateString(), ".txt");
};
export var getCharacterCount = function getCharacterCount(text) {
  return text.length;
};
export var getWordCount = function getWordCount(text) {
  return text.trim().split(' ').length;
};
export var getSubscriptionStatus = function getSubscriptionStatus(isPaid) {
  return isPaid ? 'active' : 'non_member';
};
export var getAuthState = function getAuthState(cheggUserUuid) {
  return cheggUserUuid ? 'hard_logged_in' : 'logged_out';
};
export var getCookieDomain = function getCookieDomain(site) {
  return siteConfig(site, !isProduction()).cookieDomain;
};
export var getPublicProxyUrl = function getPublicProxyUrl(site) {
  return siteConfig(site, !isProduction()).publicProxyUrl;
};
export var getWtaiExpressUrl = function getWtaiExpressUrl(site) {
  return siteConfig(site, !isProduction()).wtaiExpressUrl;
};